class customSelect extends HTMLElement {

  constructor() {
    super();
    this.elem = this.querySelector('select');
    this.bubbles = false;
    this.mainClass = 'custom-select';
    this.titleClass = 'custom-select__title';
    this.listClass = 'custom-select__list';
    this.selectedClass = 'is-selected';
    this.openClass = 'is-open';
    this.selectOptions = this.elem.options;
    this.optionsLength = this.selectOptions.length;
    this.index = 0;
    this.closeButtonText = this.dataset.closeButton;

    // creating the select container
    this.selectContainer = document.createElement('div');
    this.selectContainer.className = this.mainClass;
    if (this.elem.id) {
      this.selectContainer.id = 'custom-' + this.elem.id;
    }

    // creating the always visible main button
    this.button = document.createElement('button');
    this.button.className = this.titleClass;
    this.button.textContent = this.generateListInnerHtml(this.selectOptions[0].textContent, '||');

    // creating the ul
    this.ul = document.createElement('ul');
    this.ul.className = this.listClass;
    this.generateOptions(this.selectOptions);

    // appending the button and the list to the container
    this.selectContainer.appendChild(this.button);
    this.selectContainer.appendChild(this.ul);
    this.svg = this.querySelector('svg');
    this.selectContainer.addEventListener('click', this.onClick.bind(this));

    // selectContainer is ready - append it and hide the original
    this.elem.parentNode.insertBefore(this.selectContainer, this.elem);
    this.elem.classList.add('visually-hidden');

    // Closes the current select on any click outside of it.
    window.addEventListener('click', this.clickedOutside.bind(this));

    if(window.innerWidth >= 768 ) {
        // When sticky and scrolling up, close select dropdown
        let oldValue = 0
        let newValue = 0
        window.addEventListener('scroll', (e) => {
          newValue = window.pageYOffset;
          if (oldValue > newValue) {
            this.close(this.ul);
          }
          oldValue = newValue;
        });
    }
  }

  /**
   * generateOptions
   * @description Render options for the whole select
   */
  generateOptions(options) {
    for (var i = 0; i < options.length; i++) {
      const li = document.createElement('li');
      li.innerHTML = this.generateListInnerHtml(options[i].textContent.trim(), '||', options[i].disabled);
      li.setAttribute('data-value', options[i].value);
      li.setAttribute('data-index', this.index++);


      var optionsValue = options[i].value
      var optionsValueDown = optionsValue.toLowerCase();
      var style = '';

      // order by size (letters)
      var letters = ['xs','s','m','l','xl','xs/s','s/m','m/l','l/xl'];
      if (letters.includes(optionsValueDown)) {
        var count = 0
        letters.forEach(letter => {
          count++;
          if (letter === optionsValueDown) {
            style = `order:${count}`;
          }
        });

      // order by size (numbers)
      }

      li.setAttribute('style', style);

      if (options[i].disabled) {
        li.classList.add('disabled');
      }

      if (this.selectOptions[this.elem.selectedIndex].textContent === options[i].textContent) {
        li.classList.add(this.selectedClass);
        this.button.innerHTML = this.generateListInnerHtml(options[i].textContent, '||');
      }

      this.ul.appendChild(li);

      // if last item add a close button
      if ( this.closeButtonText !== '' && i === options.length - 1 ) {
        const closeButton = document.createElement('li');
        const closeIcon =
          `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" fill-rule="evenodd" d="M6.343 6.343a1 1 0 0 1 1.414 0L12 10.586l4.243-4.243a1 1 0 1 1 1.414 1.414L13.414 12l4.243 4.243a1 1 0 1 1-1.414 1.414L12 13.414l-4.243 4.243a1 1 0 0 1-1.414-1.414L10.586 12 6.343 7.757a1 1 0 0 1 0-1.414Z" clip-rule="evenodd"/>
          </svg>`;
        closeButton.innerHTML = `${closeIcon} <span>${this.closeButtonText}</span>`;
        closeButton.classList.add('custom-select__close');
        this.ul.appendChild(closeButton);
      }

    }
  }

  /**
   * onClick
   * @description - Handles the clicks on current select.
   */
  onClick(e) {
    e.preventDefault();

    var t = e.target;

    if (t.className === this.titleClass) this.toggle(this.ul);

    // Handle clicks on klaviyo-bis-trigger links
    if (t.classList.contains('klaviyo-bis-trigger')) {
      const parentLi = t.closest('li');
      if (parentLi) this.handleVariantChange(parentLi);
      return;
    }

    if (t.tagName === 'LI') {
      if (t.classList.contains('custom-select__close')) {
        this.close(this.ul);
      } else {
        this.handleVariantChange(t);
      }
    }
  }

  /**
   * handleVariantChange
   * @description - Handle the variant change logic for both li and klaviyo clicks
   */
  handleVariantChange(liElement) {
    this.button.innerHTML = liElement.innerHTML;

    this.elem.options.selectedIndex = liElement.getAttribute('data-index');
    this.elem.options.selectedValue = liElement.getAttribute('data-value');

    // trigger 'change' event
    const evt = this.bubbles ? new CustomEvent('change', true) : new CustomEvent('change');
    this.elem.dispatchEvent(evt);

    // highlight the selected
    for (let i = 0; i < this.optionsLength; i++) {
      this.ul.querySelectorAll('li')[i].classList.remove(this.selectedClass);
    }
    liElement.classList.add(this.selectedClass);

    // remove selected from placeholder
    const placeholderOption = document.querySelector('option[name="placeholder"]');
    placeholderOption?.removeAttribute('selected');

    // set the original select to the current value and trigger select change
    this.elem.value = this.elem.options.selectedValue;
    this.elem.dispatchEvent(new Event("change", {
      "bubbles": true
    }));

    this.close(this.ul);
  }

  /**
   * generateListInnerHtml
   * @description Toggles the open/close state of the select on title's clicks.
   * @param {string} string - The string to split and format.
   * @param {string} separator - The separator to use to split the string.
   * @param {boolean} disabled - Whether the option is disabled, so we can add a Klaviyo link.
   * @returns {string} The formatted HTML string.
   */
  generateListInnerHtml(string, separator = '+', disabled = false) {
    if (string === '') return false;

    var html = string;
    var stringSplit = string.split(separator);

    if(stringSplit[0] !== undefined && stringSplit[1] !== undefined) {
      html = `
        ${disabled ? '<a class="klaviyo-bis-trigger custom-select__klaviyo" href="#">' : ''}
        <span class="first">${stringSplit[0]}</span>
        <span class="last">${stringSplit[1]}</span>
        ${disabled ? '</a>' : ''}`
      ;
    }

    return html;
  }

  /**
   * toggle
   * @description Toggles the open/close state of the select on title's clicks.
   */
  clickedOutside(e) {
    if (!this.selectContainer.contains(e.target)){
      this.close(this.ul);
    }
  }

  /**
   * toggle
   * @description Toggles the open/close state of the select on title's clicks.
   */
  toggle(ul) {
    ul.classList.toggle(this.openClass);
  }

  /**
   * open
   * @description Opens the select.
   */
  open(ul) {
    ul.classList.add(this.openClass);
  }

  /**
   * close
   * @description Closes the select.
   */
  close(ul) {
    ul.classList.remove(this.openClass);
  }
}

if (!customElements.get('custom-select')) {
  customElements.define('custom-select', customSelect);
}
